// extracted by mini-css-extract-plugin
module.exports = {"container":"MFormPage_container__2xNIz","content":"MFormPage_content__2zaiJ","form":"MFormPage_form__2mDZ1","form--formOpen":"MFormPage_form--formOpen__2F_cp"};